import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Typography } from '../../../../../stories/atoms';
import { ColumnFlexContainer, RowFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';
import { muiTheme } from '../../../../../theme';
import { commonTranslations } from '../../../../../translations';
import { SecondaryTextTypography } from '../../../../../App.styles';
import { BreakdownItem, MetricContainer } from './RfidApprovalsWidget.styles';

export const MetricItem: FC<{
  isDaily: boolean;
  percentValue: number;
  titleText: string;
  pieces: number;
  additionalPieces: number;
  descriptionText: string;
  approvalRateText: number;
  approvalRate: number;
  breakdownText: string;
  totalPieces: number;
  totalCounts: number;
  approvedPiecesText: string;
  nonApprovedPiecesText: string;
}> = ({
  isDaily,
  percentValue,
  titleText,
  pieces,
  additionalPieces,
  descriptionText,
  approvalRateText,
  approvalRate,
  breakdownText,
  totalPieces,
  totalCounts,
  approvedPiecesText,
  nonApprovedPiecesText,
}) => {
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('tabletPortrait'));
  const { t } = useTranslation();

  return (
    <MetricContainer flex={1} hasBorder padding={isMobile ? [3, 3] : [4]} borderRadius={[2]} isMobile={isMobile}>
      <RowFlexContainer flex={isMobile ? 1 : undefined} justifyContent="between">
        <ColumnFlexContainer alignItems="start" flex={1}>
          <Typography type={isMobile ? 'caption' : 'button'}>{titleText}</Typography>

          <Tooltip
            text={
              <ColumnFlexContainer>
                <Typography color="white">
                  {approvedPiecesText}: {pieces}
                </Typography>
                <Typography color="white">
                  {nonApprovedPiecesText}: {additionalPieces}
                </Typography>
              </ColumnFlexContainer>
            }
          >
            <div>
              <Typography type={isMobile ? 'body4' : 'h4'} margin={isMobile ? [1, 0, 0, 0] : [2, 0, 0, 0]}>
                {pieces + additionalPieces}{' '}
                {t(commonTranslations.pieces.key, commonTranslations.pieces.defaultValue)}
              </Typography>
            </div>
          </Tooltip>
        </ColumnFlexContainer>

        {!isMobile && (
          <ColumnFlexContainer
            backgroundColor="backgroundSelectedDark"
            borderRadius={[100]}
            alignItems="center"
            justifyContent="center"
            width={[20]}
            height={[20]}
          >
            <Typography type={'button'}>{percentValue.toFixed(2)}%</Typography>
          </ColumnFlexContainer>
        )}

        {isMobile && (
          <ColumnFlexContainer alignItems="center" justifyContent="center">
            <Typography type={'h3'}>{percentValue.toFixed(2)}%</Typography>
          </ColumnFlexContainer>
        )}
      </RowFlexContainer>

      {!isMobile && (
        <ColumnFlexContainer flex={1} justifyContent="center">
          <SecondaryTextTypography>{descriptionText}</SecondaryTextTypography>
        </ColumnFlexContainer>
      )}

      <RowFlexContainer gap={[2]} alignItems="center">
        <BreakdownItem isMobile={isMobile}>
          <Typography type={isMobile ? 'body3' : 'button'} margin={[0]}>
            {isDaily
              ? `${additionalPieces}/${totalPieces}`
              : `${totalCounts === 0 ? 0 : Math.round(additionalPieces / totalCounts)} pcs`}
          </Typography>

          <SecondaryTextTypography type={isMobile ? 'legal' : 'caption'} textAlign="center">
            {breakdownText}
          </SecondaryTextTypography>
        </BreakdownItem>

        <BreakdownItem isMobile={isMobile}>
          <Typography type={isMobile ? 'body3' : 'button'} textAlign="center" margin={[0]}>
            {approvalRate.toFixed(2)}%
          </Typography>

          <SecondaryTextTypography type={isMobile ? 'legal' : 'caption'}>
            {approvalRateText}
          </SecondaryTextTypography>
        </BreakdownItem>
      </RowFlexContainer>
    </MetricContainer>
  );
};
